export const REVIEW_PROMPT_INTENT_EVENT = "review-prompt:intent";
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/search?sca_esv=bb7afd09d3b0f8fc&rlz=1C1CHBF_enIN1207IN1207&sxsrf=ANbL-n6HYrW4u83gaQzguguXYuN8AmJYIA:1780406222320&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOZqaLXzbJqzIb4KyPXUgPd9SXIm3gSubA3YohPtfYjIWWfcO5F6lriw9mikEI7kLcAZdrnz6kW1e6KsS8hvDdj82W__GsyHibbwUJQbNBY0F1WyVeV0K6ZmBdPclToYdd7i6sgu5u61SaY04nt9Bi_TuZ-Yw&q=KRRISH+IMPEX+%28+KRRISH+ECOWARE+INDUSTRIES+PVT+LTD+%29+Reviews&sa=X&ved=2ahUKEwjFtr-D0uiUAxUjXGwGHdn3OFoQ0bkNegQIKBAH&biw=1280&bih=598&dpr=1.5#lrd=0x390d016a7b05f04d:0x3b5e1f3d253e9290,3,,,,";

export const triggerReviewPromptIntent = (source) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(REVIEW_PROMPT_INTENT_EVENT, {
      detail: { source },
    })
  );
};

const reviewPromptUtils = {
  REVIEW_PROMPT_INTENT_EVENT,
  GOOGLE_REVIEW_URL,
  triggerReviewPromptIntent,
};

export default reviewPromptUtils;
